import types from "./types";
import API from "../../axios/physician/PhysicianApi";
import handleAPIErrorResponse from "../../utils/handleAPIResponseError";

import { message } from "antd";

const setCaseTicketListLoading = (status) => ({
  type: types.SET_CASE_TICKETS_LIST_LOADING,
  data: status,
});

const setCaseTicketList = (payload, count) => ({
  type: types.SET_CASE_TICKETS_LIST,
  payload,
  count,
});

const setCaseTicketNotificationCount = (count) => ({
  type: types.SET_CASE_TICKET_NOTIFICATION_COUNT,
  count,
});

const setNotificationsCountByTicketIds = (payload) => ({
  type: types.SET_NOTIFICATIONS_COUNT_BY_TICKET_IDS,
  payload,
});

function getCaseTickets(status) {
  return (dispatch) => {
    dispatch(setCaseTicketListLoading(true));
    API.getCaseTickets(status)
      .then((res) => {
        const { data } = res;
        if (data && data.success) {
          const { payload } = data;
          if (payload.tickets) {
            const mappedData = payload.tickets.map((item) => {
              return {
                ...item,
                ticketno: item._id,
                lastResponseTime: item.lastResponseTime,
                status: item.status,
                caseno: item.caseId,
                unreadCount: item.unreadCount,
              };
            });
            const mappedCount = payload.count;
            dispatch(setCaseTicketList(mappedData, mappedCount));
          }
          message.success("Case Tickets Listed");
        } else {
          message.warning("Unable to list Case Tickets");
        }
        dispatch(setCaseTicketListLoading(false));
      })
      .catch((error) => {
        handleAPIErrorResponse(
          error,
          "Error occured while listing Case Tickets"
        );
        dispatch(setCaseTicketListLoading(false));
      });
  };
}

function getCaseTicketNotificationCount() {
  return (dispatch) => {
    API.getCaseTickets()
      .then((res) => {
        const { data } = res;
        if (data && data.success) {
          const { payload } = data;
          if (payload) {
            dispatch(setCaseTicketNotificationCount(payload.unread));
          }
        } else {
          console.log("Unable to get Case Tickets Notification Count");
        }
      })
      .catch((error) => {
        handleAPIErrorResponse(
          error,
          "Error occured while getting Case Ticket Notification Count"
        );
      });
  };
}

function getUnreadMessagesCountByTicketIds(ticketIds) {
  return (dispatch) => {
    API.getUnreadMessagesCountByTicketIds(ticketIds)
      .then((res) => {
        if (!res.data.success) {
          throw Error();
        }
        dispatch(setNotificationsCountByTicketIds(res.data.payload));
      })
      .catch((error) => {
        handleAPIErrorResponse(
          error,
          "Error occured while getting Case Ticket Notification Count by ticketId"
        );
      });
  };
}

const markTicketAsRead = (ticketId, successCallback) => {
  return (dispatch) => {
    API.markTicketAsRead({ ticketId })
      .then(res => {
        if (res.data?.success) {
          successCallback && successCallback();
          getCaseTicketNotificationCount()(dispatch);
        } else {
          console.log("Unable to mark ticket as read");
        }
      })
  }
}

const actions = {
  getCaseTickets,
  getCaseTicketNotificationCount,
  getUnreadMessagesCountByTicketIds,
  markTicketAsRead,
};

export default actions;
